import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-900 pb-12 pt-8 sm:pb-16 sm:pt-12" data-id="element-196" data-mp="9k0b6xwjpxkw">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gold-500/60" aria-hidden="true" data-id="element-197" data-mp="4mi5rhhqm0hn" />

      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-198" data-mp="128pjbgw0r365">
        <div className="flex flex-col items-center gap-3" data-id="element-199" data-mp="xa4ipgcuuhh6">
          <div className="flex items-center gap-2" data-id="element-200" data-mp="x8joxsyd72kd">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl border border-gold-500/50 bg-navy-800" data-id="element-201" data-mp="s9zz3hgnh6mq">
              <ShieldCheckIcon className="h-4.5 w-4.5 text-gold-400" aria-hidden="true" data-id="element-202" data-mp="nbyh6zuyndcu" />
            </span>
            <span className="font-display text-lg font-bold tracking-tight text-cream-100" data-id="element-203" data-mp="381xiwrlewq70">
              Occlusion <span className="text-gold-400" data-id="element-204" data-mp="3j89618jhw3nf">360™</span>
            </span>
          </div>
          <p className="rounded-full border border-gold-500/40 bg-navy-800 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-gold-300 sm:text-[11px]" data-id="element-205" data-mp="3o85bzdbr655m">
            The Occlusal Decision System
          </p>
        </div>

        <h1 className="mt-7 text-center font-display text-[30px] font-bold leading-[1.12] text-cream-100 sm:text-5xl lg:text-[56px]" data-id="element-206" data-mp="3e7uvnjuf8hm8">
          What if the articulating paper{' '}
          <em className="not-italic text-gold-400" data-id="element-207" data-mp="359szbhlmud5a">
            isn’t showing you the whole problem?
          </em>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-center text-[16px] leading-relaxed text-cream-100/80 sm:text-lg" data-id="element-208" data-mp="2qloea6z3xpjc">
          The articulating paper should be the{' '}
          <strong className="font-bold text-cream-100" data-id="element-209" data-mp="2hk8685vrlzia">LAST step</strong> — not the
          first. Discover a structured system to analyze occlusal cases, organize
          your clinical reasoning, and approach adjustments with greater clarity
          before reaching the final refinement stage.
        </p>

        <div className="mx-auto mt-7 w-full max-w-2xl" data-id="element-210" data-mp="naji3pzjuhg2">
          <img src="https://cdn.magicpatterns.com/uploads/35Q7FCvj9pSkKVzceXR43r/OCLUSION360-EN.png" alt="Occlusion 360 complete system: 6 premium volumes and 5 professional bonuses shown across book, tablet and laptop mockups" className="w-full" width={1280} height={1280} data-id="element-211" data-mp="ibyq2dugb42p" />
        </div>

        <p className="mx-auto -mt-2 max-w-xl text-center text-[14px] font-semibold leading-relaxed text-cream-100/85 sm:text-base" data-id="element-212" data-mp="162lyr1c6xxqb">
          Includes 6 Premium Volumes + 5 Professional Bonuses + decision maps,
          checklists, analysis matrices, and clinical case studies.
        </p>

        <div className="mx-auto mt-7 w-full max-w-md" data-id="element-213" data-mp="3lui6mj3rolho">
          <CTAButton id="hero-cta" label="Get access to Occlusion 360™" subline="Instant access · One-time payment of $27 USD · 1-year access · 7-day guarantee" data-id="element-214" data-mp="3hqu105yp3zz2" />
        </div>

        <div className="mx-auto mt-9 w-full max-w-md" data-id="element-215" data-mp="21bpmjgknzt1q">
          <Countdown tone="dark" data-id="element-216" data-mp="269zjnwpy93pz" />
          <p className="mt-4 text-center text-[11px] font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-217" data-mp="268y69llgo553">
            Limited-time launch price
          </p>
          <div className="mt-4" data-id="element-218" data-mp="2fzsuuwm6jgtp">
            <ScarcityBar tone="dark" data-id="element-219" data-mp="2g0luzeqmv82v" />
          </div>
          <p className="mt-3 text-center text-[12px] leading-snug text-cream-100/60" data-id="element-220" data-mp="2g257qvd2z0zw">
            Currency conversion is handled automatically according to your country.
          </p>
        </div>
      </div>
    </header>;
}